import React, { PureComponent } from "react";
import GoogleMapContainer from "../utils/GoogleMapContainer";
import { Marker, InfoWindow } from "react-google-maps";
import RechercheResultTable from "./RechercheResultTable";
import { I18n } from "react-i18next";
import "../utils/i18n";

const initialState = {
  isMarkerOpen: []
};

const MarkerWithInfo = props => (
  <Marker position={props.position} onClick={props.handleOnClick}>
    {props.isOpen && (
      <InfoWindow onCloseClick={props.handleOnClick}>
        <div>{props.children}</div>
      </InfoWindow>
    )}
  </Marker>
);

class RechercheResult extends PureComponent {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  toggleMarkerInfoWindow(id) {
    let isMarkerOpen = [];
    if (this.state.isMarkerOpen.length === 0) {
      isMarkerOpen[id] = true;
    } else {
      // falls man das InfoWindow wechselt, ohne das vorherige zu schliessen
      if (Object.keys(this.state.isMarkerOpen)[0] !== id) {
        isMarkerOpen[id] = true;
      }
    }
    this.setState({ isMarkerOpen: isMarkerOpen });
  }

  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <div className="row result-header">
              {this.props.massnahmen.length > this.props.limit && (
                <div>
                  <i className="icon ion-alert-circled" />{" "}
                  {t("recherche.warningPart1")}
                  {this.props.massnahmen.length}
                  {t("recherche.warningPart2")}
                  {this.props.limit}
                  {t("recherche.warningPart3")}
                </div>
              )}
            </div>
            <div className="row">
              <div className="karte-container">
                <GoogleMapContainer
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAdmbcLZbNjruP22UpYEFrMwJH7-1HVoc0&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `100%` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                  center={{ lat: 46.8, lng: 8.2 }}
                  zoom={7}
                  options={{
                    streetViewControl: false,
                    mapTypeControl: true,
                    scrollwheel: false
                  }}
                >
                  {this.props.massnahmen
                    .slice(0, this.props.limit)
                    .map(
                      ({
                        lat,
                        lng,
                        id,
                        massnahme,
                        datum,
                        gebaeude,
                        plz,
                        ort,
                        orgelbauer
                      }) => (
                        <MarkerWithInfo
                          position={{
                            lat: parseFloat(lat),
                            lng: parseFloat(lng)
                          }}
                          key={id}
                          handleOnClick={() => this.toggleMarkerInfoWindow(id)}
                          isOpen={this.state.isMarkerOpen[id] || false}
                          onCloseClick={() => this.toggleMarkerInfoWindow(id)}
                        >
                          <div>
                            {massnahme}, {datum}
                          </div>
                          <div>{gebaeude}</div>
                          <div>{orgelbauer}</div>
                          <div>
                            {plz} {ort}
                          </div>
                        </MarkerWithInfo>
                      )
                    )}
                </GoogleMapContainer>
              </div>
              <RechercheResultTable
                massnahmen={this.props.massnahmen}
                limit={this.props.limit}
              />
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default RechercheResult;



// WEBPACK FOOTER //
// ./src/recherche/RechercheResult.js